module.exports = __webpack_public_path__ + "static/media/corpora.a6a1e3df.jpg";